
/*
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#176ED3',
        secondary: '#ee6090',
        defecation: '#02C07C',
        temperature: '#EB2121',
        milk: '#DB069F',
        sleep: '#FF5722',
      },
    },
  },
});
*/

import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import '@mdi/font/css/materialdesignicons.css'; // MDIアイコンのCSSをインポート
import { ja as dateJa } from 'date-fns/locale';
import DateFnsAdapter from '@date-io/date-fns';
// 👇 1. Vuetify本体の日本語翻訳データをインポート
import { ja } from 'vuetify/locale';

export default createVuetify({
  components,  // ★ Vuetifyコンポーネントを有効化
  directives,
  locale: {
    locale: 'ja',        // デフォルトの言語を日本語に
    fallback: 'en',      // 日本語がない場合は英語に
    messages: { ja },    // 翻訳データを登録
  },
  theme: {
    defaultTheme: 'light', // 💡 修正点: dark: false は defaultTheme: 'light' に変更
    themes: {
      light: {
        colors: { // 💡 修正点: カラーオブジェクト全体を 'colors' キーでラップ
          primary: '#176ED3',
          secondary: '#ee6090',
          // 💡 修正点: カスタムカラーも 'colors' 内にそのまま定義可能
          defecation: '#02C07C',
          temperature: '#EB2121',
          milk: '#DB069F',
          sleep: '#FF5722',
        },
      },
      // dark: { ... } // 必要に応じてダークテーマの設定を追加
    },
  },
  date: {
    adapter: DateFnsAdapter,
    locale: {
      ja: dateJa,
    },
  },
  // 💡 Vuetify 3では、使用するコンポーネントのスタイルやアイコンをインポートする必要がある場合が多い
  // components: {}, // 必要なコンポーネントをインポート
  // directives: {}, // 必要なディレクティブをインポート
});